import { useContext, useState } from 'react';
import { IoListCircleSharp } from 'react-icons/io5';
import { ShareListContext } from '../../context/shareList';
import './styles.css'
import { MdContentCopy } from 'react-icons/md';
import { useAuth } from '../../context/auth';
import { toast } from 'react-toastify';
import { FaChevronDown, FaMinus } from 'react-icons/fa6';


const PoputListImoveis = () => {
    const { user } = useAuth();
    const { imovelList, removeImovel, isOpen, setIsOpen } = useContext(ShareListContext);
    const [iconVisible, setIconVisible] = useState(true);

    const openPopup = () => {
        setIconVisible(!iconVisible);
        setTimeout(() => {
            setIsOpen(true);
        }, 50);
    };

    const closePopup = () => {
        setIsOpen(false);
        setTimeout(() => {
            setIconVisible(true);
        }, 400);
    };


    const copyList = () => {

        const links = imovelList.map(imovel => {

            let text = '';

            if (user) {
                text = `
            ${imovel.nome}
            https://portal.hubnogueira.com.br/perfil/${user.id_corretor}/imovel/${imovel.id}
            `;
            } else {
                text = `
            ${imovel.nome}
            https://portal.hubnogueira.com.br/imovel/${imovel.id}
            `;
            }
            return text;
        });

        navigator.clipboard.writeText(links.join('\n')).then(() => {
            toast.success('Links copiados com sucesso', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                draggable: true,
                progress: undefined,
            })
        })

    }

    return (
        <>

            <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: '9999' }}>
                <div style={{ position: 'relative' }}>


                    <div style={{ ...styles.container, display: `${iconVisible ? 'none' : ''}` }} className={` popup_list ${!isOpen ? 'hidden' : ''}`}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 0px' }}>
                            <h4>Imóveis para compartilhar</h4>
                            <FaChevronDown className='icon_close' style={{ margin: '0px 6px' }} size={20} color='rgb(15, 36, 69)' onClick={() => closePopup()} />
                        </div>

                        <ul style={{ listStyle: 'none', }}>

                            {imovelList.length > 0 ?
                                imovelList.map((imovel) => (
                                    <li className='list_imoveis_share' style={{ display: 'flex', width: '100%', borderBottom: '1px solid rgba(0,0,0, .1)', marginBottom: '10px', paddingBottom: '10px', alignItems: 'center', justifyContent: 'space-between' }} key={imovel.id}>
                                        <div onClick={() => window.open(user ? `perfil/${user.id_corretor}/imovel/${imovel.id}` : `/imovel/${imovel.id}`, '_blank')} className='div_link_imovel' style={{ width: '100%', maxWidth: '88%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            <img src={imovel.image} alt='foto_imovel' style={{ width: '35px', height: '35px', borderRadius: '50%', marginRight: '10px' }} />
                                            {imovel.id_display ? imovel.id_display : imovel.id} - {imovel.nome}
                                        </div>
                                        <div onClick={() => removeImovel(imovel.id)} className="div_delete_imovel" style={{ padding: '5px', transition: 'all 0.2s ease-in-out', alignItems: 'center', display: 'flex', justifyContent: 'center', cursor: 'pointer', borderRadius: '100%' }}>
                                            <FaMinus size={20} />
                                        </div>

                                    </li>
                                )) :
                                <li>
                                    Você ainda não tem imóveis na lista.
                                </li>}
                        </ul>

                        {imovelList.length > 0 && <button disabled={imovelList.length === 0} onClick={copyList} className='div_link_imovel' style={{ marginBottom: '5px', width: '100%', backgroundColor: 'rgb(15, 36, 69)', border: 'none', color: '#fff', padding: '10px', borderRadius: '5px', cursor: 'pointer' }} ><MdContentCopy /> Compartilhar</button>}
                    </div>


                    <div className='list_imoveis_icon' onClick={openPopup} style={{ display: `${(!iconVisible || imovelList.length <= 0) ? 'none' : ''}`, cursor: 'pointer', }}>

                        <span style={{ fontSize: '0.7rem', backgroundColor: 'rgb(209, 46, 46)', color: '#fff', borderRadius: '50%', width: '20px', height: '20px', display: `${!iconVisible ? 'none' : 'flex'}`, justifyContent: 'center', alignItems: 'center', fontWeight: '600', position: 'absolute', top: '-2px', right: '-2px', }}>{imovelList.length}</span>

                        <div style={{
                            position: 'absolute',
                            top: '5px',
                            left: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            zIndex: '-1',
                        }}></div>
                        <IoListCircleSharp color="rgb(15, 36, 69)" size={54} />


                    </div>
                </div>
            </div>
        </>
    );
};

export default PoputListImoveis;

const styles = {
    container: { backgroundColor: '#fff', padding: '10px 18px 10px 24px', borderRadius: '10px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)', transition: 'all 0.3s ease-in-out' }
};